import { useSearchParams } from "react-router-dom";

function useSetParamsURL() {
    const [searchParams, setSearchParams] = useSearchParams();

    const setParamsUrl = (novoValor: string, prop?: string) => {

        const propName = prop || "codigo";
        const newSearchParams = new URLSearchParams(searchParams);

        newSearchParams.set(propName, novoValor);
        setSearchParams(newSearchParams);
    };

    const setMultipleParamsUrl = (values: { [key: string]: any }) => {
        const newSearchParams = new URLSearchParams();
        Object.keys(values).forEach((key) => {
            newSearchParams.set(key, values[key]);
        });

        setSearchParams(newSearchParams);
    };

    const clearParamsUrl = () => {
        const empty = new URLSearchParams({})
        setSearchParams(empty);
    };

    const clearSingleParamUrl = (prop: string) => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete(prop);
        setSearchParams(newSearchParams);
    };

    return {
        searchParams,
        setParamsUrl,
        setMultipleParamsUrl,
        clearParamsUrl,
        clearSingleParamUrl
    };
}

export default useSetParamsURL;